export const LIST_ENTITY_NAMES = {
	USERS: 'users',
	PERMISSIONS: 'permissions',
	PERMISSIONS_SET: 'permissionsSet',
	BULK_PERMISSIONS: 'bulkPermissions',
	BULK_PERMISSION_CSV: 'bulkPermissionCsv',
	BULK_PERMISSION_CSV_STATUS: 'bulkPermissionCsvStatus',
	BULK_USER_CSV: 'bulkUserCsv',
	BULK_USER_CSV_STATUS: 'bulkUserCsvStatus'
};
export const SETTINGS_V2_ACTION = {
	login: 'login',
	createUser: 'createUser',
	editUser: 'editUser',
	listUsers: 'listUsers',
	getUsers: 'getUsers',
	deleteUsers: 'deleteUsers',
	listPermission: 'listPermission',
	createPermission: 'createPermission',
	editPermission: 'editPermission',
	deletePermission: 'deletePermission',
	getPermissionSets: 'getPermissionSets',
	createPermissionSet: 'createPermissionSet',
	editPermissionSet: 'editPermissionSet',
	deletePermissionSet: 'deletePermissionSet',
	assignBulkPermissions: 'assignBulkPermissions',
	removeBulkPermissions: 'removeBulkPermissions',
	bulkActions: 'bulkActions',
	bulkAssignPermissions: 'bulkAssignPermissions',
	bulkRemovePermissions: 'bulkRemovePermissions',
	getPermissions: 'getPermissions',
	listBulkPermissionCsvRequests: 'listBulkPermissionRequests',
	createBulkPermissionCsvRequest: 'createBulkPermissionRequest',
	checkBulkPermissionCsvRequestStatus: 'checkBulkPermissionRequestStatus',
	listBulkUserCsvRequests: 'listBulkUserRequests',
	createBulkUserCsvRequest: 'createBulkUserRequest',
	checkBulkUserCsvRequestStatus: 'checkBulkUserRequestStatus'
} as const;

export const PAGE_NAMES: { [key: string]: string } = {
	settingsV2: 'settingsV2',
	permissionsManagement: 'permissionsManagement'
};

export const RESOURCES: { [key: string]: string } = {
	user: 'user',
	permission: 'permission',
	permissionSet: 'permissionSet',
	bulkPermission: 'bulkPermission',
	bulkPermissionCsv: 'bulkPermissionCsv',
	bulkUserCsv: 'bulkUserCsv'
};

type Resources = {
	[key: string]: string;
};

export const SETTINGS_V2_RESOURCES: Resources = {
	user: 'user',
	permissionsManagement: 'permissionsManagement',
	bulkUserCsv: 'bulkUserCsv'
};

export const PERMISSIONS_MANAGEMENT_RESOURCES: Resources = {
	permission: 'permission',
	permissionSet: 'permissionSet',
	bulkPermission: 'bulkPermission',
	bulkPermissionCsv: 'bulkPermissionCsv',
	bulkUserCsv: 'bulkUserCsv'
};

export const userUrlPrefix: string = '/dashboard/forward/settingsV2-user';
export const bulkPermissionUserUrlPrefix: string = '/dashboard/forward/permissionsManagement-user';
export const permissionUrlPrefix: string = '/dashboard/forward/permissionsManagement-permission';
export const permissionSetUrlPrefix: string = '/dashboard/forward/permissionsManagement-permissionSet';
export const unauthorizedUrlPrefix: string = '/dashboard/unauthorized';

export const PERMISSION_TYPE = {
	PERMISSIONS: 'permissions',
	PERMISSION_SETS: 'permissionSets',
	BULK_PERMISSIONS: 'bulkPermissions'
};

export const ACTION_IDS = {
	BULK_ACTIONS: 'bulkActions',
	EDIT: 'edit',
	DELETE: 'delete',
	ADD: 'add'
};

export const ACTION_NAME = {
	BULK_PERMISSIONS: 'Bulk Permissions',
	EDIT: 'Edit',
	DELETE: 'Delete',
	ADD: 'Add'
};
